import React from 'react';
import {Link} from 'react-router-dom';

const Navbar = () => {
    return (
        <nav style={styles.nav}>
            <ul style={styles.ul}>
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/about">About</Link>
                </li>
                <li>
                   <Link to="/employess">Employess</Link>
                </li>
                <li>
                   <Link to="/contacts">Contacts</Link> 
                </li>
            </ul>
        </nav>
            
        
    );
}

export default Navbar

const styles = {
    nav: {
        
        
    },
    ul: {
        display: "flex",
        justifyContent: "space-between",
        margin: "40px 90px ",
        listStyle: "none",
        fontSize: "30px",
        color: "green"

    },

}